// easing functions http://goo.gl/5HLl8
Math.easeInOutQuad = function (t, b, c, d) {
	t /= d / 2;
	if (t < 1) {
		return c / 2 * t * t + b
	}
	t--;
	return -c / 2 * (t * (t - 2) - 1) + b;
};

Math.easeInCubic = function (t, b, c, d) {
	var tc = (t /= d) * t * t;
	return b + c * (tc);
};

Math.inOutQuintic = function (t, b, c, d) {
	var ts = (t /= d) * t,
		tc = ts * t;
	return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
};

// requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
const requestAnimFrame = (function () {
	return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
		window.setTimeout(callback, 1000 / 60);
	};
})();

export const scrollTo = (element, to, duration, callback) => {
	// because it's so fucking difficult to detect the scrolling element, just move them all
	function move(amount) {
		element.scrollTop = amount;
		// document.documentElement.scrollTop = amount;
		// document.body.parentNode.scrollTop = amount;
		// document.body.scrollTop = amount;
	}

	function position() {
		// return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
		return element.scrollTop;
	}

	let start = position(),
		change = to - start,
		currentTime = 0,
		stopRequested = false,
		increment = 20;

	const registerTouchEventToPreventScroll = () => {
		const hasTouchStartEvent = 'ontouchstart' in document.createElement('div');
		let event = hasTouchStartEvent ? 'touchstart' : 'mousedown';

		const preventScrollOnTouch = () => {
			stopRequested = true;
			document.removeEventListener(event, preventScrollOnTouch);
		};

		document.addEventListener(event, preventScrollOnTouch, false);
	}


	duration = (typeof (duration) === 'undefined') ? 500 : duration;

	const animateScroll = function () {
		// increment the time
		currentTime += increment;
		// find the value with the quadratic in-out easing function
		const val = Math.easeInOutQuad(currentTime, start, change, duration);
		// move the document.body
		move(val);
		// do the animation unless its over
		if (!stopRequested && currentTime < duration) {
			requestAnimFrame(animateScroll);
		} else {
			if (callback && typeof (callback) === 'function') {
				// the animation is done so lets callback
				callback();
			}
		}
	};

	registerTouchEventToPreventScroll()
	animateScroll();


}
